import { render, staticRenderFns } from "./TaxesMarketValueSearch.vue?vue&type=template&id=4b84c74a&scoped=true&lang=pug"
import script from "./TaxesMarketValueSearch.vue?vue&type=script&lang=ts"
export * from "./TaxesMarketValueSearch.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4b84c74a",
  null
  ,true
)

export default component.exports